<script setup lang="ts">
  import type { IPaymentLink } from '@/components/main-footer/types'
  import { PAYMENT_LOGOS } from '@/utils/constants/paymentLogo'

  const props = defineProps<{ paymentOptions: IPaymentLink[] | null }>()

  const paymentOptionsWithLogos = computed(
    () =>
      props.paymentOptions?.map((payment) => ({
        ...payment,
        logo: PAYMENT_LOGOS[payment.name]
      })) || []
  )
</script>

<template>
  <div class="payment-options">
    <ul class="flex list-none flex-wrap gap-x-6 gap-y-4 p-0 sm:gap-x-10 sm:gap-y-6">
      <li
        v-for="payment in paymentOptionsWithLogos"
        :key="payment.name"
        class="flex items-center"
      >
        <NuxtLink
          :to="payment.href"
          :alt="$t(`payment.logo.linkAlt.${payment.name}`)"
          class="block"
        >
          <NuxtImg
            :src="`/payments/${payment.name}.svg`"
            :alt="$t(`payment.logo.alt.${payment.name}`)"
            :width="payment.logo?.width"
            :height="payment.logo?.height"
            loading="lazy"
          />
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>
